import React, { FC } from 'react'
import { IBidRateCoachGrades } from 'types/graphqlTypes'
import { Tag, TAG_SIZE, TAG_STYLE } from 'transfix-ui'
import { titleCase } from 'utils/titleCase'

const SCORE_STYLE: Record<IBidRateCoachGrades, TAG_STYLE> = {
  poor: TAG_STYLE.error,
  fair: TAG_STYLE.warning,
  good: TAG_STYLE.success,
} as const

interface RateCoachTagProps {
  rateCoachGrade: IBidRateCoachGrades
}

export const RateCoachTag: FC<RateCoachTagProps> = ({ rateCoachGrade }) => {
  return (
    <Tag
      label={titleCase(rateCoachGrade)}
      size={TAG_SIZE.xsmall}
      tagStyle={SCORE_STYLE[rateCoachGrade]}
    />
  )
}
